import MessagesLayout   from "@/app/user/messages/messages.layout.tsx";   // keeps sidebar
import MessagesIndex    from "@/app/user/messages/messages.page.tsx";     // sidebar-only view
import ChatRoomPage     from "@/app/user/messages/[room-id]/room.page.tsx";

const withLayout = (Comp: React.FC) => () => (
    <MessagesLayout>
        <Comp />
    </MessagesLayout>
);

export const messages_routes = [
    {
        path   : "/messages",
        element: withLayout(MessagesIndex)(),
    },
    {
        path   : "/messages/:roomId",
        element: withLayout(ChatRoomPage)(),
    },
];